import { render, staticRenderFns } from "./ManagementPage.vue?vue&type=template&id=5593db38&scoped=true"
import script from "./ManagementPage.vue?vue&type=script&lang=js"
export * from "./ManagementPage.vue?vue&type=script&lang=js"
import style0 from "./ManagementPage.vue?vue&type=style&index=0&id=5593db38&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5593db38",
  null
  
)

export default component.exports